const explicitBackend = process.env.REACT_APP_BACKEND_URL || "";
const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";

export const BACKEND_URL = explicitBackend || browserOrigin;
export const API_BASE_URL = `${BACKEND_URL}/api`;
